export default "__VITE_ASSET__2a5b6efa__"